<template>
  <div
    class="xs:min-w-84 xs:w-84 bg-ul-orange-100 m-4 h-full w-72 min-w-72 overflow-hidden shadow-sm duration-300 hover:shadow-lg"
  >
    <div class="border-ul-orange-400 m-4 flex flex-col items-center justify-center border-2 border-solid p-4">
      <h3 class="text-ul-orange-400 w-full text-2xl font-bold">{{ ticket.title }}</h3>
      <h3 class="text-ul-orange-400 w-full py-2 text-xl font-semibold">kr {{ ticket.price }}</h3>
      <p class="v-html text-ul-orange-400" v-html="ticket.perks" />
      <a
        class="border-ul-orange-400 text-ul-orange-400 hover:ul-orange-200 hover:bg-ul-orange-200 mt-6 border-2 border-solid px-16 py-4 font-bold duration-300"
        :href="ticket.link"
        rel="noopener noreferrer"
        target="_blank"
      >
        Kjøp
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Ticket } from '../types'

defineProps<{ ticket: Ticket }>()
</script>

<style lang="scss"></style>
